import React, { useContext, useState, useCallback } from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import metadata from 'libphonenumber-js/metadata.min.json';
import BookingFooter from './BookingFooter';

import { PageContext } from '../context';
import ActionDialog from '../../../components/Dialogs/ActionDialog';
import { ContentWrapper } from '../styles';
import { LPText } from '../../styles';
import { PhoneInputWrapper } from '../../../components/Forms/styles';
import ServiceType from './ServiceType';

const BookingType = () => {
  const context = useContext(PageContext);
  const {
    footerQuestions: { footerHeading, footerParagraph },
    queryData: {
      getVpn: {
        bookingLandingPage: { serviceListInstr },
        availableServices: services,
      },
    },
  } = context;

  const [modalOpen, setModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, [setModalOpen]);

  const handleSubmitModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  return (
    <>
      <ContentWrapper nopadding>

        {services && services.length === 0 && (
          <LPText padded w800>
            No services available. Check back soon.
          </LPText>
        )}
        {services && services.length > 0 && (
          <>
            <LPText padded w800>
              {serviceListInstr}
            </LPText>
            <ContentWrapper>
              {services.map((service) => (
                <ServiceType key={service.id} service={service} />
              ))}
            </ContentWrapper>
          </>
        )}
        <ActionDialog
          open={modalOpen}
          title="Enter the phone number used to register for a membership, we will shoot you a text with log-in details."
          maxWidth="sm"
          buttonCopy="Text Me"
          handleCancel={handleCloseModal}
          handleConfirm={handleSubmitModal}
          isValid={isValidPhoneNumber(phoneNumber)}
          disableBackdropClick
        >
          <PhoneInputWrapper light>
            <PhoneInput
              defaultCountry="US"
              label="Phone"
              metadata={metadata}
              placeholder="Mobile # (w/country code)"
              value={phoneNumber}
              onChange={(value) => setPhoneNumber(value)}
            />
          </PhoneInputWrapper>

          <LPText description centered>
            Phone number should have 9 characters or more
          </LPText>
        </ActionDialog>
      </ContentWrapper>
      <BookingFooter
        handleClick={handleClick}
        footerHeading={footerHeading}
        footerParagraph={footerParagraph}
      />
    </>
  );
};

BookingType.propTypes = {};

export default BookingType;
